import React, { forwardRef } from 'react';

import cx from 'classnames';

import s from './index.module.css';

const StickyHeader = forwardRef(({ children }, ref) => {
  const [header, ...body] = children;

  return (
    <div className={cx(s.flex, s.main)}>
      <div className={s.header}>{header}</div>
      <div className={s.content} ref={ref}>
        {body}
      </div>
    </div>
  );
});

export default StickyHeader;
